import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContractSitesComponent } from './contracts/add-edit-contract/contract-sites/contract-sites.component';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { ContractClustersComponent } from './contracts/add-edit-contract/contract-clusters/contract-clusters.component';
import { ContractOrganizationsComponent } from './contracts/add-edit-contract/contract-organizations/contract-organizations.component';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { ContractInvoicingReportComponent } from './contracts/contract-invoicing-report/contract-invoicing-report.component';
import { GoBackButtonComponent } from '@shared/components/go-back-button/go-back-button.component';
import { ContractFiltersActionbar } from '@shared/components/contract-filters-actionbar/contract-filters-actionbar';
import { ContractsFiltersComponent } from './contracts/contracts-filters/contracts-filters.component';
import { AddEditOrganizationComponent } from './organizations/add-organization/add-edit-organization.component';
import { AdminOrganizationUsersComponent } from './organizations/add-organization/organization-users/admin-organization-users.component';
import { OrganizationContractsComponent } from './organizations/add-organization/organization-contracts/organization-contracts.component';
import { EditUserComponent } from './users/edit-user/edit-user.component';
import { TypedTemplateDirective } from '@shared/directives/typed-template.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AdminRoutingModule,
    NgxDatatableModule,
    NgSelectComponent,
    NgOptionComponent,
    GoBackButtonComponent,
    ReactiveFormsModule,
    ContractFiltersActionbar,
    TypedTemplateDirective,
    ContractClustersComponent,
    ContractSitesComponent,
    ContractOrganizationsComponent,
    ContractInvoicingReportComponent,
    ContractsFiltersComponent,
    AddEditOrganizationComponent,
    AdminOrganizationUsersComponent,
    OrganizationContractsComponent,
    EditUserComponent,
  ],
  exports: [
    ContractClustersComponent,
    ContractSitesComponent,
    ContractOrganizationsComponent,
    ContractInvoicingReportComponent,
    ContractsFiltersComponent,
    AddEditOrganizationComponent,
  ],
})
export class AdminModule {}
